export const apiKey = "31caa6e7382cd860cfe38b4a39825730";
export const omdbapiKey = "46b3f5da";
